import * as appConstants from "../infrastructure/appConstants";

export const getDescripcionMetodoPago = (codigo) => {
  switch (codigo) {
    case appConstants.CODIGO_METODO_PAGO_CULQI:
      return appConstants.DESCRIPCION_METODO_PAGO_CULQI;
    case appConstants.CODIGO_METODO_PAGO_CUENTA_AHORROS:
      return appConstants.DESCRIPCION_METODO_PAGO_CUENTA_AHORROS;
    default:
      return "";
  }
};

export const getDescripcionMoneda = (codigo) => {
  switch (codigo) {
    case appConstants.CODIGO_MONEDA_SOLES:
      return appConstants.DESCRIPCION_MONEDA_SOLES;
    case appConstants.CODIGO_MONEDA_DOLARES:
      return appConstants.DESCRIPCION_MONEDA_DOLARES;
    default:
      return "";
  }
};

export const getNombreMoneda = (codigo) => {
  switch (codigo) {
    case appConstants.CODIGO_MONEDA_SOLES:
      return appConstants.NOMBRE_MONEDA_SOLES;
    case appConstants.CODIGO_MONEDA_DOLARES:
      return appConstants.NOMBRE_MONEDA_DOLARES;
    default:
      return "";
  }
};

export const getCodigoMonedaIso = (codigoMoneda) => {
  switch (codigoMoneda) {
    case appConstants.CODIGO_MONEDA_SOLES:
      return appConstants.CODIGO_MONEDA_ISO_SOLES;
    case appConstants.CODIGO_MONEDA_DOLARES:
      return appConstants.CODIGO_MONEDA_ISO_DOLARES;
    default:
      return "";
  }
};

export const getNombreCampania = (indicadorOrigen) => {
  switch (indicadorOrigen) {
    case appConstants.CODIGO_ORIGEN_CAMPANIA_MICRO:
      return appConstants.DESCRIPCION_ORIGEN_CAMPANIA_MICRO;
    case appConstants.CODIGO_ORIGEN_CAMPANIA_MICASH:
      return appConstants.DESCRIPCION_ORIGEN_CAMPANIA_MICASH;
    default:
      return appConstants.DESCRIPCION_ORIGEN_CAMPANIA_LINEA_PRYMERA;
  }
};

export const getSubTituloCampania = (indicadorOrigen) => {
  switch (indicadorOrigen) {
    case appConstants.CODIGO_ORIGEN_CAMPANIA_MICRO:
      return appConstants.SUBTITULO_ORIGEN_CAMPANIA_MICRO;
    case appConstants.CODIGO_ORIGEN_CAMPANIA_MICASH:
      return appConstants.SUBTITULO_ORIGEN_CAMPANIA_MICASH;
    default:
      return appConstants.SUBTITULO_ORIGEN_CAMPANIA_LINEA_PRYMERA;
  }
};
